// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
            img {
                margin-right: 10px;
                cursor: pointer;
            }
            .icon-disable {
                pointer-events: none;
                cursor: not-allowed;
                display: inline-block !important;
            }
            .icon-enable {
                cursor: pointer;
                display: inline-block !important;
                color: #3d3db8;
            }
            .icon-enable-delete {
                cursor: pointer;
                display: inline-block !important;
                color: #eb0000;
            }
        `, "",{"version":3,"sources":["webpack://./src/app/shared/components/actions-button-renderer/actions-button-renderer.component.ts"],"names":[],"mappings":";YACY;gBACI,kBAAkB;gBAClB,eAAe;YACnB;YACA;gBACI,oBAAoB;gBACpB,mBAAmB;gBACnB,gCAAgC;YACpC;YACA;gBACI,eAAe;gBACf,gCAAgC;gBAChC,cAAc;YAClB;YACA;gBACI,eAAe;gBACf,gCAAgC;gBAChC,cAAc;YAClB","sourcesContent":["\n            img {\n                margin-right: 10px;\n                cursor: pointer;\n            }\n            .icon-disable {\n                pointer-events: none;\n                cursor: not-allowed;\n                display: inline-block !important;\n            }\n            .icon-enable {\n                cursor: pointer;\n                display: inline-block !important;\n                color: #3d3db8;\n            }\n            .icon-enable-delete {\n                cursor: pointer;\n                display: inline-block !important;\n                color: #eb0000;\n            }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
